module.exports = __webpack_public_path__ + "static/media/SD Card.f4c03093.png";